import React from 'react'
import * as R from 'ramda'
import withTranslate from 'redux-polyglot/translate'
import Button from '@components/button'
import { getLargestButtonSize } from 'domain/button'
import withConnect from './connector'
import { ErrorMessageWrapper as Wrapper } from '../style'
import { Props } from './types'

const Network: React.FC<Props> = ({
  p,
  partner,
  onReloadApp,
  screenSize
}) => (
  <Wrapper
    partner={partner}
  >
    <div className='Error__InformationBlock'>
      <h1 className='Error__Title'>
        {p.tc('connexion_lost_title')}
      </h1>
      <h2 className='Error__SubTitle'>
        {`${p.tc('connexion_lost_subtitle') as string}.`}
      </h2>
      <p className='Error__Sentence'>
        {`${p.tc('network_error_happened') as string}.`}
      </p>
      <div className='Error__WrapperButton'>
        <Button
          shouldFitToContainer
          label={p.tc('reload_page')}
          onClick={onReloadApp}
          size={getLargestButtonSize(screenSize)}
          variant='primary'
        />
      </div>
    </div>
    <div className='Error__Image' />
  </Wrapper>
)

export default R.compose(
  withConnect,
  withTranslate('errors')
)(Network)
